import React from 'react';

export function RocketInclined() {
  return (
    <svg
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0609 81.7105C24.7484 83.0813 23.0486 83.5713 22.0543 82.5772L8.09029 68.6154C7.09602 67.6213 7.58579 65.9214 8.95652 65.6087L17.8101 63.5887L27.0795 72.8566L25.0609 81.7105Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.4191 47.7858L42.8745 21.2454L14.2278 49.8967C11.4358 52.6891 11.4362 57.2162 14.2286 60.0082L30.6609 76.4379C33.4534 79.2299 37.9804 79.2295 40.7723 76.4371L69.4191 47.7858ZM34.6624 61.9623C37.953 61.9621 40.6204 59.2943 40.6201 56.0036C40.6198 52.713 37.9521 50.0457 34.6614 50.0459C31.3708 50.0461 28.7034 52.714 28.7037 56.0046C28.704 59.2952 31.3718 61.9626 34.6624 61.9623ZM52.837 43.7846C52.8373 47.0753 50.1699 49.7431 46.8793 49.7433C43.5887 49.7436 40.9209 47.0762 40.9206 43.7856C40.9203 40.495 43.5877 37.8271 46.8783 37.8269C50.169 37.8267 52.8367 40.494 52.837 43.7846Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.4194 47.7855L76.8194 18.1752C77.4737 15.5569 75.102 13.1856 72.4838 13.8403L42.8748 21.2451L69.4194 47.7855Z"
        fill="currentColor"
      />
    </svg>
  );
}
